import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import NavLink from '../nav_link';

const styles = () => ({
    subheading: {
        paddingLeft: '32px',
        maxHeight: '40px',
        paddingRight: '1.0rem',
    },
});

class MAListCertificates extends React.Component {
    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                <Collapse component="li" in={this.props.isOpen} timeout="auto">
                    <List disablePadding>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/certificates/configuring-trusts"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Configuring Trusts" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/certificates/certificate-alarms"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Certificate Alarms" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/certificates/third-party-ssl-certificates"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Third-Party Certificates" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/certificates/multi-manager"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Multi-Manager Trusts" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/certificates/wildcard-certificates"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Agent Wildcard Certificates" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/certificates/updating-third-party-certificates"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Updating Certificates" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/certificates/updating-manager-keystores"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Updating Manager Keystores" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/certificates/troubleshooting-certificates"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Troubleshooting Certificates" />
                            </ListItem>
                        </NavLink>
                    </List>
                </Collapse>
            </React.Fragment>
        );
    }
}

MAListCertificates.propTypes = {
    classes: PropTypes.object.isRequired,
    isOpen: PropTypes.object,
    handleDrawerToggle: PropTypes.func,
    onActive: PropTypes.func,
};

export default withStyles(styles)(MAListCertificates);
